import styled from "@emotion/styled"
import { Typography } from "@mui/material"

export const Wrapper = styled.div`
  visibility: hidden;
`

export const Title = styled(Typography)`
  color: inherit;
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
`
